// - Wenn in Partials gearbeitet werden soll, dann benutzt folgenden Schnippsel:
//  import './NAME-DER-DATEI';

import "./../../../../../auw_product/Resources/Private/Js/main.js";
import "./../../../../../auw_memolist/Resources/Private/Js/main.js";
import "./_stickyHeaderNav";
import "./lightbox";

$(document).ready(function () {});
